
















import { Component, Vue } from 'vue-property-decorator';
import { IItemProperty } from '@/store/types/ItemProperty';
import { State, Getter, Mutation } from 'vuex-class';

import ItemList from './pageContents/ItemList.vue';
import ShowMoreButtomComponent from './pageContents/ShowMoreButtomComponent.vue';
import PreviewImage from './PreviewImage.vue';

@Component({
  components: {
    ShowMoreButtomComponent,
    ItemList,
    PreviewImage,
  },
})
export default class ContentContainer extends Vue {
  @State
  public itemsCounter!: number;
  @State
  public isDisplayList!: boolean;

  @Mutation
  public setDisplayList!: (isList: boolean) => any;

  @Getter public applyFilters!: any;
}
